import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

export const AttemptedForm = ({ form }) => {
	const {
		control,
		register,
		formState: { errors },
	} = form;

	return (
		<Fragment>
			<Box my={3}>
				<TextField
					// InputLabelProps={{ shrink: true }}
					{...register("reason", {})}
					fullWidth
					label="Reason (Optional)"
					variant="outlined"
					multiline
					minRows={1}
					// value={brand.name}
					error={Boolean(errors.reason)}
					helperText={errors.reason?.message}
				/>
			</Box>
			<LocalizationProvider dateAdapter={AdapterMoment}>
				<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
					{/* Start Date */}
					<Controller
						name={`next_delivery_date`}
						control={control}
						rules={
							{
								// required: "Start date is required",
							}
						}
						render={({ field }) => (
							<DatePicker
								label="Next Delivery Date(Optional)"
								inputFormat="DD/MM/YYYY"
								minDate={moment()}
								{...field}
								value={field.value ?? null}
								renderInput={(params) => (
									<TextField
										fullWidth
										{...params}
										error={!!errors?.next_delivery_date}
										helperText={
											errors.next_delivery_date?.message
										}
									/>
								)}
							/>
						)}
					/>
				</Box>
			</LocalizationProvider>
		</Fragment>
	);
};
